import VAutoComplete from 'vuetify/es5/components/VAutocomplete'
import gql from 'graphql-tag'

export default {
  name: 'select-person',
  extends: VAutoComplete,
  props: {
    allowBlank: {
      type: Boolean,
      default: false
    },
    itemText: {
      type: [String, Array, Function],
      default: 'vollerNameEmail'
    },
    itemValue: {
      type: [String, Array, Function],
      default: 'id'
    },
  },
  watch: {
    personen(personen) {
      if (this.allowBlank) {
        const pers = [{ id: 0, vollerNameEmail: "[Andere Person]" }].concat(personen || [])
        this.$emit("update:items", pers)
      } else {
        this.$emit("update:items", personen)
      }
    }
  },
  apollo: {
    personen: {
      query: gql`query {
        personen(order: "vorname, nachname", where: { status: "angestellt"}) {
          id
          vollerNameEmail
        }
      }`,
    }
  }
}
